<template>
<div>
  Home
</div>
</template>

<script>
export default {
  name: 'Home',
  components: {
  },
  data: () => ({
    tab: null,
    items: [
      'web', 'shopping', 'videos', 'images', 'news'
    ]
  })
}
</script>
